import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Login Page" */ '@/views/loginPage/loginPage.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/eventManagement',
    name: 'Event_Management',
    component: () => import(/*webpackChunkName: "Event Management" */ '@/views/eventManagementPage/eventManagementPage.vue')
  },
  {
    // GS-901 — the result console: both engines, every product, phone to desktop
    path: '/results',
    name: 'Results',
    component: () => import(/*webpackChunkName: "Results" */ '@/views/resultsPage/resultsPage.vue')
  },
  {
    path: '/resultUpdate',
    name: 'Result_Update',
    component: () => import(/*webpackChunkName: "Event Management" */ '@/views/resultUpadatePage/resultUpdatePage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
